import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GridContainer, Card, ImageWrapper, Content, Title, Description, ReadMore } from './styledcomponents';
import { data } from './data';
import { FaArrowRight } from 'react-icons/fa';

export default function BlogList() {
  const navigate = useNavigate();

  const handleCardClick = (link) => {
    if (link.startsWith('http://') || link.startsWith('https://')) {
      // External link, open in a new tab
      window.open(link, '_blank');
    } else {
      // Internal link, navigate within the app
      navigate(link);
    }
  };

  return (
    <GridContainer>
      {[...data].reverse().map((item) => (
        <Card key={item.id} onClick={() => handleCardClick(item.link)}>
          <ImageWrapper>
            <img src={item.image} alt={item.title} />
          </ImageWrapper>
          <Content>
            <Title>{item.title}</Title>
            <Description>{item.desc}</Description>
            <ReadMore>
              Read More <FaArrowRight size={14} />
            </ReadMore>
          </Content>
        </Card>
      ))}
    </GridContainer>
  );
}
